import { Collapse, Icon, Tooltip } from '@blueprintjs/core';
import styles from './RefinanceCalculator.module.css';
import { useState } from 'react';
import { RefinanceCalculatorItem } from './RefinanceCalculatorItem';
import { Currency } from '@axo/shared/data-access/types';

export interface RefinanceCalculatorProps {
  remainingAmount: number;
  interestBearing: number;
  nonInterestBearing: number;
  cashAmount: number;
  totalAmount: { number: number; message: string };
  setCashAmount: (value: number) => void;
  numberOfRemainingAmountSelected: number;
  numberOfInterestBearingSelected: number;
  numberOfNonInterestBearingSelected: number;
  totalInterestRate: number;
  currency?: Currency;
}

export const RefinanceCalculator = ({
  remainingAmount,
  interestBearing,
  nonInterestBearing,
  cashAmount,
  totalAmount,
  setCashAmount,
  numberOfRemainingAmountSelected,
  numberOfInterestBearingSelected,
  numberOfNonInterestBearingSelected,
  totalInterestRate,
  currency,
}: RefinanceCalculatorProps) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <div className={styles.container}>
      <button
        type="button"
        className={styles.title}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div className={styles.header}>
          <Icon icon={'calculator'} />
          <span>Refinance calculator</span>
        </div>
        {isOpen ? <Icon icon={'chevron-up'} /> : <Icon icon={'chevron-down'} />}
      </button>
      <Collapse isOpen={isOpen}>
        <div className={styles.content}>
          <RefinanceCalculatorItem
            icon={'dollar'}
            title={`Remaining amount (${numberOfRemainingAmountSelected})`}
            amount={remainingAmount}
            intent={'primary'}
            currency={currency}
          />
          <Icon icon={'plus'} className={styles.operatorIcons} />
          <RefinanceCalculatorItem
            icon={'credit-card'}
            title={`Interest bearing (${numberOfInterestBearingSelected})`}
            amount={interestBearing}
            intent={'warning'}
            currency={currency}
          />
          <Icon icon={'plus'} className={styles.operatorIcons} />
          <RefinanceCalculatorItem
            icon={'credit-card'}
            title={`Non-interest bearing (${numberOfNonInterestBearingSelected})`}
            amount={nonInterestBearing}
            intent={'warning'}
            currency={currency}
          />
          <Icon icon={'plus'} className={styles.operatorIcons} />
          <RefinanceCalculatorItem
            icon={'bank-account'}
            title={'Cash amount'}
            amount={cashAmount}
            intent={'none'}
            currency={currency}
            editable
            setValue={setCashAmount}
          />
          <Icon icon={'equals'} className={styles.operatorIcons} />
          <Tooltip
            content={totalAmount.message}
            position={'bottom'}
            className={styles.item}
          >
            <RefinanceCalculatorItem
              title={'Total amount'}
              amount={totalAmount.number}
              intent={'empty'}
              currency={currency}
              secondaryTitle={'Average interest rate'}
              secondaryValue={`${totalInterestRate}%`}
            />
          </Tooltip>
        </div>
      </Collapse>
    </div>
  );
};
